<template>
  <div>
    <div class="container">
    <div class="title">
      <h1>Наши услуги</h1>
    </div>
  </div>
    <WhatWeDo mode="short"/>
    <Stack />
    <div class="text-center">
      <router-link to="/portfolio" class="button">Смотреть портфолио</router-link>
    </div>
    <Clients />
    <DarkModule />
    <section class="section">
      <div class="container">
        <div class="row mt-60">
          <div class="col-m-5">
            <div class="contacts">
              <div class="contacts__sub">Контакты</div>
              <div class="contacts__title">Чем мы можем помочь вам?</div>
              <ul class="contacts__data">
                <li>
                  <a href="mailto:sales@giveandgo.ru">sales@giveandgo.ru</a>
                </li>
                <li>
                  <a href="tel:+79062106621">+7 906 21 066 21</a><span> (Whatsapp, Telegram, Viber)</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-m-7">
            <Feedback />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
const name = "Home"

import Stack from '@/components/Stack.vue'
import Feedback from '@/components/Feedback.vue'
import DarkModule from '@/components/DarkModule.vue'
import WhatWeDo from '@/components/WhatWeDo.vue'
import Clients from '@/components/Clients.vue'

export default {
  name,
  components: {
    Stack,
    Feedback,
    DarkModule,
    Clients,
    WhatWeDo
  }
}

</script>
